import useInView from '../hooks/useInView';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const CategoriesSection = () => {
  const [ref, inView] = useInView({ threshold: 0.15 });
  const { t, i18n } = useTranslation('common');
  const images = [
    "/assets/imgs/Home/5th Sec/1.png",
    "/assets/imgs/Home/5th Sec/2.png",
    "/assets/imgs/Home/5th Sec/3.png",
  ];
  const categories = (t('home.categories.cards', { returnObjects: true }) || []).map((c, idx) => ({
    id: idx + 1,
    title: c.title,
    description: c.description,
    image: images[idx] || images[0]
  }));

  const fallbackByLng = {
    ar: [
      { title: 'الآباء', description: 'نص تجريبي يُستخدم في الطباعة والتنضيد منذ القرن السادس عشر.' },
      { title: 'قراءة الأطفال', description: 'نص تجريبي يُستخدم في الطباعة والتنضيد منذ القرن السادس عشر.' },
      { title: 'مقدمو الرعاية', description: 'نص تجريبي يُستخدم في الطباعة والتنضيد منذ القرن السادس عشر.' }
    ],
    ur: [
      { title: 'والدین', description: 'یہ نمونہ متن ہے جو 16ویں صدی سے پرنٹنگ اور ٹائپ سیٹنگ میں استعمال ہو رہا ہے۔' },
      { title: 'بچوں کی پڑھائی', description: 'یہ نمونہ متن ہے جو 16ویں صدی سے پرنٹنگ اور ٹائپ سیٹنگ میں استعمال ہو رہا ہے۔' },
      { title: 'سرپرست', description: 'یہ نمونہ متن ہے جو 16ویں صدی سے پرنٹنگ اور ٹائپ سیٹنگ میں استعمال ہو رہا ہے۔' }
    ],
    es: [
      { title: 'Padres', description: 'Texto de ejemplo del sector de la impresión y tipografía desde el siglo XVI.' },
      { title: 'Lectura infantil', description: 'Texto de ejemplo del sector de la impresión y tipografía desde el siglo XVI.' },
      { title: 'Cuidadores', description: 'Texto de ejemplo del sector de la impresión y tipografía desde el siglo XVI.' }
    ],
    de: [
      { title: 'Eltern', description: 'Platzhaltertext der Druck- und Satzindustrie seit dem 16. Jahrhundert.' },
      { title: 'Kinder lesen', description: 'Platzhaltertext der Druck- und Satzindustrie seit dem 16. Jahrhundert.' },
      { title: 'Betreuende', description: 'Platzhaltertext der Druck- und Satzindustrie seit dem 16. Jahrhundert.' }
    ],
    fr: [
      { title: 'Parents', description: 'Texte factice utilisé dans l’imprimerie et la composition depuis le XVIe siècle.' },
      { title: 'Lecture des enfants', description: 'Texte factice utilisé dans l’imprimerie et la composition depuis le XVIe siècle.' },
      { title: 'Aidants', description: 'Texte factice utilisé dans l’imprimerie et la composition depuis le XVIe siècle.' }
    ],
    pt: [
      { title: 'Pais', description: 'Texto de exemplo usado na indústria gráfica desde o século XVI.' },
      { title: 'Leitura infantil', description: 'Texto de exemplo usado na indústria gráfica desde o século XVI.' },
      { title: 'Cuidadores', description: 'Texto de exemplo usado na indústria gráfica desde o século XVI.' }
    ],
    it: [
      { title: 'Genitori', description: 'Testo segnaposto usato nella stampa e tipografia dal XVI secolo.' },
      { title: 'Lettura per bambini', description: 'Testo segnaposto usato nella stampa e tipografia dal XVI secolo.' },
      { title: 'Caregiver', description: 'Testo segnaposto usato nella stampa e tipografia dal XVI secolo.' }
    ],
    ja: [
      { title: '保護者', description: '16世紀から印刷と組版で使われてきたダミーテキストです。' },
      { title: '子どもの読書', description: '16世紀から印刷と組版で使われてきたダミーテキストです。' },
      { title: 'ケアギバー', description: '16世紀から印刷と組版で使われてきたダミーテキストです。' }
    ],
    hi: [
      { title: 'अभिभावक', description: 'यह 16वीं सदी से प्रिंटिंग और टाइपसेटिंग उद्योग में प्रयोग किया जाने वाला नमूना पाठ है।' },
      { title: 'बच्चों की पढ़ाई', description: 'यह 16वीं सदी से प्रिंटिंग और टाइपसेटिंग उद्योग में प्रयोग किया जाने वाला नमूना पाठ है।' },
      { title: 'संरक्षक', description: 'यह 16वीं सदी से प्रिंटिंग और टाइपसेटिंग उद्योग में प्रयोग किया जाने वाला नमूना पाठ है।' }
    ],
    zh: [
      { title: '家长', description: '自16世纪以来用于印刷和排版行业的示例文本。' },
      { title: '儿童阅读', description: '自16世纪以来用于印刷和排版行业的示例文本。' },
      { title: '照护者', description: '自16世纪以来用于印刷和排版行业的示例文本。' }
    ],
    ru: [
      { title: 'Родители', description: 'Пример текста, используемый в полиграфии и наборе со XVI века.' },
      { title: 'Чтение для детей', description: 'Пример текста, используемый в полиграфии и наборе со XVI века.' },
      { title: 'Опекуны', description: 'Пример текста, используемый в полиграфии и наборе со XVI века.' }
    ]
  };

  const lng = (i18n.language || 'en').split('-')[0];
  const hasLocalResource = Array.isArray(i18n.getResource(lng, 'common', 'home.categories.cards'));
  const effectiveCategories = hasLocalResource && categories.length > 0
    ? categories
    : (fallbackByLng[lng] || []).map((c, idx) => ({ id: idx + 1, image: images[idx] || images[0], ...c }));

  return (
    <section 
      ref={ref}
      className="relative py-20 lg:py-24 bg-cover bg-center bg-no-repeat" 
      id="categories"
      style={{
        backgroundImage: 'url("/assets/imgs/Home/5th Sec/bg.png")'
      }}
    >
      {/* Background overlay */}
      <div className="absolute inset-0 bg-black/10"></div>
      
      <div className="container mx-auto px-8 lg:px-16 relative z-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {effectiveCategories.map((category, i) => (
            <div key={category.id} className={`group transition-all duration-700 ease-out ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`} style={{ transitionDelay: `${120 + i * 120}ms` }}>
              <div className={`bg-white/95 backdrop-blur-sm rounded-xl overflow-hidden shadow-xl transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl h-full ${inView ? 'scale-100' : 'scale-95'}`}>
                <div className="bg-[#e8dcc8] flex items-center justify-center">
                  <img 
                    src={category.image} 
                    alt={category.title}
                    className="w-full h-auto object-contain"
                  />
                </div>
                {/* Divider between image and card */}
                <div className="h-[3px] w-full bg-[#496f62]"></div>
                <div className="bg-[#f1ece1] p-6 text-center">
                  <h3 className="font-poppins font-medium text-xl text-text-dark mb-4 leading-tight">
                    {category.title}
                  </h3>
                  <p className="font-poppins text-text-gray text-sm leading-relaxed mb-6">
                    {category.description}
                  </p>
                  <Link 
                    to="../shop" 
                    className="inline-block bg-brown hover:bg-brown-dark text-cream px-8 py-3 rounded text-sm font-normal uppercase tracking-wide transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
                  >
                    {t('home.readMore')}
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoriesSection;
